<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="search">
                    <div class="card">
                        <!-- <div class="card-header">
                            <i class="fa fa-search"></i> Pesquisar
                        </div> -->
                        <!-- <div class="card-block">
                            <div class="form-group row">
                                <div class="col-md-6 col-xs-12">
                                    <label>Nome</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="filter.nome"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                              <div
                                    class="col-md-6 col-xs-12"
                                >
                                    <label>Idioma</label>
                                    <Select2
                                        placeholder="Selecione"
                                        v-model="filter.idioma"
                                        :options="tiposIdiomas"
                                    >
                                        <option value selected>Selecione</option>
                                    </Select2>
                                </div>
                            </div>

                            <hr />
                        </div> -->
                        <div class="card-footer">
                            <div class="form-group row">
                                <div class="col-md-6 text-left">
                                    <button type="button" @click="create" class="btn btn-primary">
                                        Novo País
                                        <i class="fa fa-angle-right"></i>
                                    </button>
                                </div>
                                <!-- <div class="col-md-6 text-right">
                                    <button
                                        type="button"
                                        @click="clean"
                                        class="btn btn-primary"
                                    >Limpar</button>
                                    <button type="submit" class="btn btn-default">
                                        <i class="fa fa-search"></i> Pesquisar
                                    </button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <dw-table-header :size="size" @finish="updateSize" :pagination="list"></dw-table-header>
                    </div>
                    <div class="card-block">
                        <table class="table table-bordered table-striped table-md">
                            <dw-table-head :headers="headers" :editable="true" @update="sort"></dw-table-head>
                            <tbody>
                                <tr v-for="item in list.rows" :key="item.toString('hex')">
                                    <td :data-label="headers[0].name">{{ item.id }}</td>
                                    <td :data-label="headers[1].name">
                                      {{ item.nome }}

                                      <span
                                          v-if="item.ativo"
                                          class="badge badge-success"
                                      >Ativo</span>
                                      <span v-else class="badge badge-danger">Inativo</span>
                                    </td>
                                    <td :data-label="headers[2].name">{{ item.codigo }}</td>
                                    <td :data-label="headers[3].name">{{ item.ddi }}</td>
                                    <td :data-label="headers[4].name">{{ item.idioma }}</td>
                                    <td>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            @click="edit(item.id)"
                                        >
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger btn-sm"
                                            @click="remove(item.id)"
                                        >
                                            <i class="fa fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <dw-pagination
                            :pagination="list"
                            :page="page"
                            @update="fetchData"
                            :offset="size"
                        ></dw-pagination>
                    </div>
                </div>
            </div>
            <!--/.col-->
        </div>
        <!--/.row-->
    </div>
</template>

<script>
import {
    isUndefinedOrNullOrEmpty,
    clearCpfCnpj,
    clearPhone,
    formatPhone,
    formatCpf
} from "@/services/string";
import SelectClient from "../../components/Input/SelectClient";
import Select from "../../components/Input/Select";
import SelectApi from "../../components/Input/SelectApi";
import Select2 from '../../components/Input/Select2';
import Collections from "@/helpers/collections";
import Facade from "../../facade/facade";
const facade = new Facade();

export default {
    components: { SelectClient, SelectApi, Select, Select2 },
    data() {
        return {
            headers: [
                { name: "Cód.", key: "id" },
                { name: "Nome", key: "nome" },
                { name: "Código", key: "codigo" },
                { name: "DDI", key: "ddi" },
                { name: 'Idioma', key: 'idioma' }
            ],
            list: {},
            filter: {
              idioma: ''
            },
            size: 20,
            page: 0,
            order: ["id", "ASC"],
            model: {},
            tiposIdiomas: Collections.idiomas
        };
    },
    computed: {
        isAdmin() {
            return facade.isAdmin();
        }
    },
    methods: {
        sort(data) {
            this.order = [data.key, data.direction];
            this.fetchData(this.page);
        },
        clean() {
            this.filter = {};
        },
        create() {
            this.$router.push({ name: "new-country" });
        },

        edit(id) {
            this.$router.push({
                name: "edit-country",
                params: { id: id }
            });
        },

        remove(id) {
            this.$swal({
                title: "Você tem certeza?",
                text: "Não será possível  reverter esta operação",
                showCancelButton: true,
                confirmButtonText: "Sim, deletar!",
                cancelButtonText: "Não, cancelar!"
            }).then(
                () => {
                    this.$loading.show(true);

                    let ret = facade.deleteCountry(id);
                    ret.then(response => {
                        this.$notify.success(
                            "",
                            "Registro removido com sucesso."
                        );
                        this.fetchData(0);
                        this.$loading.show(false);
                    }).catch(e => {
                        this.$notify.error(
                            "Erro!",
                            "Ocorreu um problema ao deletar o país."
                        );
                        this.$loading.show(false);
                    });
                },
                dismiss => {}
            );
        },

        fetchData(page) {
            let vm = this;
            vm.page = page;

            let params = {
                params: {
                    page: page,
                    size: vm.size,
                    order: vm.order
                }
            };
            for (let key in this.filter) {
                if (this.filter.hasOwnProperty(key)) {
                    params["params"][key] = this.filter[key];
                }
            }

            this.$loading.show(true);
            let ret = facade.listCountry(params);
            ret.then(response => {
                vm.list = response.data.data;
                this.$loading.show(false);
            }).catch(e => {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar os Países."
                );
                this.$loading.show(false);
            });
        },
        search() {
            this.fetchData(0);
        },
        updateSize(value) {
            let vm = this;
            vm.size = value;
            this.fetchData(0);
        }
    },
    beforeMount() {
        this.fetchData(0);
    }
};
</script>



// WEBPACK FOOTER //
// List.vue?73571b85